<template>
    <div>
        <b-form-group
            id="input-group-1"
            class="mb-0 kyc-status-radio overwrite-radio"
            :label="field.label"
            :label-for="field.label"
        >
            <b-form-checkbox-group
                :options="field.options"
                name="radio-options"
            ></b-form-checkbox-group>
        </b-form-group>
    </div>
</template>

<script>
export default {
    props: ['field'],
}
</script>
